var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 8C0.75 4.00217 4.00127 0.75 8 0.75C11.9987 0.75 15.25 4.00217 15.25 8C15.25 11.9978 11.9978 15.25 8 15.25C4.00215 15.25 0.75 11.9978 0.75 8ZM7.95543 2.3047C4.83567 2.32873 2.3047 4.8745 2.3047 8C2.3047 11.1404 4.85965 13.6955 8 13.6955C11.1404 13.6955 13.6953 11.1404 13.6953 8C13.6953 4.85964 11.1402 2.3047 8 2.3047H7.95543ZM7.99937 5.82477C6.79807 5.82477 5.82422 6.79862 5.82422 7.99992C5.82422 9.20122 6.79807 10.1751 7.99937 10.1751C9.20067 10.1751 10.1745 9.20122 10.1745 7.99992C10.1745 6.79862 9.20067 5.82477 7.99937 5.82477Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.86c3ddd3f2a55d7509942dc724f58062.svg";
export { ForwardRef as ReactComponent };